var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListViewOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 4.80001H2.40001C1.95841 4.80001 1.60001 4.44161 1.60001 4.00001V2.40001C1.60001 1.95841 1.95841 1.60001 2.40001 1.60001H13.6C14.0416 1.60001 14.4 1.95841 14.4 2.40001V4.00001C14.4 4.44161 14.0416 4.80001 13.6 4.80001Z",
    fill: "#BABBC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 9.59999H2.40001C1.95841 9.59999 1.60001 9.24159 1.60001 8.79999V7.19999C1.60001 6.75839 1.95841 6.39999 2.40001 6.39999H13.6C14.0416 6.39999 14.4 6.75839 14.4 7.19999V8.79999C14.4 9.24159 14.0416 9.59999 13.6 9.59999Z",
    fill: "#BABBC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 14.4H2.40001C1.95841 14.4 1.60001 14.0416 1.60001 13.6V12C1.60001 11.5584 1.95841 11.2 2.40001 11.2H13.6C14.0416 11.2 14.4 11.5584 14.4 12V13.6C14.4 14.0416 14.0416 14.4 13.6 14.4Z",
    fill: "#BABBC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewOff);
export default __webpack_public_path__ + "static/media/list-view-off.ea299461569feb042b4d5c7665128b4e.svg";
export { ForwardRef as ReactComponent };